import React, { useEffect, useState } from 'react';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import { REVIEW_MEDIA_TYPE } from '../ReviewsSection/constants';

type Media = {
  media_url: string;
  media_type: number;
  temp_media_url?: string;
};

type Props = {
  media: Media;
  className?: string;
  retryCount?: number;
  retryDelay?: number;
};

const MediaWithRetry: React.FC<Props> = ({
  media,
  className = '',
  retryCount = 3,
  retryDelay = 1000,
}) => {
  const [src, setSrc] = useState<string>(media?.media_url);
  const [attempt, setAttempt] = useState<number>(0);
  const [hasError, setHasError] = useState<boolean>(false);

  // Retry on failure
  useEffect(() => {
    if (hasError && attempt <= retryCount) {
      const newSrc = `${media?.temp_media_url || media?.media_url}?retry=${Date.now()}`;
      setSrc(newSrc);
    }
  }, [attempt, media?.media_url, hasError]);

  const handleError = () => {
    if (attempt < retryCount) {
      setTimeout(() => setAttempt((prev) => prev + 1), retryDelay);
    } else {
      setHasError(true);
    }
  };

  return hasError ? (
    <div className="tw-text-center tw-text-sm tw-text-gray-400">Failed to load media</div>
  ) : media?.media_type !== REVIEW_MEDIA_TYPE.IMAGE ? (
    <>
      <video
        src={src}
        onError={handleError}
        className={`tw-max-h-full tw-max-w-full ${className}`}
      />
      <span className="tw-absolute tw-left-1/2 tw-top-1/2 tw-flex -tw-translate-x-1/2 -tw-translate-y-1/2 tw-text-white">
        <PlayCircleOutlineRoundedIcon />
      </span>
    </>
  ) : (
    <img
      src={src}
      alt="media"
      onError={handleError}
      className={`tw-max-h-full tw-max-w-full ${className}`}
    />
  );
};

export default MediaWithRetry;
